(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var section = document.querySelector(".product-recommendations");
  if (section === null) { return; }
  var tpl = section.querySelector("template.rec-template");
  if (!tpl) { return; }

  var vendor = (section.dataset.vendor || "").trim().toLowerCase();
  var max = parseInt(section.dataset.max, 10) || 5;

  var render = function(recItems) {
    var holder = document.createElement("div");
    holder.appendChild(tpl.content.cloneNode(true));
    var list = holder.querySelector(".product-list");
    var fallbackItems = Array.prototype.slice.call(list.querySelectorAll(".rec-item--fallback"));
    fallbackItems.forEach(function(el) { el.parentNode.removeChild(el); });

    var used = {};
    var count = 0;
    var add = function(item) {
      if (count >= max) { return; }
      var block = item.querySelector(".product-block");
      var id = block ? block.getAttribute("data-product-id") : null;
      if (!block || (id && used[id])) { return; }
      if (id) { used[id] = true; }
      while (item.firstChild) { list.appendChild(item.firstChild); }
      count++;
    };

    // 1. Shopifyのおすすめのうち、同じブランドのもの
    recItems.forEach(function(item) {
      var v = (item.getAttribute("data-rec-vendor") || "").trim().toLowerCase();
      if (vendor !== "" && v === vendor) { add(item); }
    });
    // 2. 足りない分を同じブランドの新着で埋める
    fallbackItems.forEach(add);

    if (count === 0) { section.innerHTML = ""; return; }
    section.innerHTML = "";
    while (holder.firstChild) { section.appendChild(holder.firstChild); }
    theme.ProductBlockManager.loadImages(section);
    theme.initAnimateOnScroll();
  };

  var request = new XMLHttpRequest();
  request.open("GET", section.dataset.url);
  request.onload = function() {
    var recItems = [];
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      recItems = Array.prototype.slice.call(container.querySelectorAll(".rec-item"));
    }
    render(recItems);
  };
  request.onerror = function() { render([]); };
  request.send();
};
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
